export default __webpack_public_path__ + "1572c6e77c13db6559324a27c4b5cffa.png";